export const exportType = [
  { id: 'Export under bond/Lut', label: 'Export under bond/Lut' },
  { id: 'Deemed Export', label: 'Deemed Export' },
  { id: 'Export With IGST', label: 'Export With IGST' },
  { id: 'SEZ With IGST Payment', label: 'SEZ With IGST Payment' },
  { id: 'without IGST Payment', label: 'without IGST Payment' },
];
